import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function ModifierType() {
    const { target, refresh } = useBoundContext()
    return (
        <FormControl>
            <FormLabel>Type</FormLabel>
            <RadioGroup
                row
                value={target.type || "percentage"}
                onChange={(e) => {
                    target.type = e.target.value
                    refresh()
                }}
            >
                <FormControlLabel value="percentage" control={<Radio />} label="Percentage" />
                <FormControlLabel value="fixed" control={<Radio />} label="Fixed amount" />
            </RadioGroup>
        </FormControl>
    )
}
